/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { GenderEnum } from './GenderEnum';
import {
    GenderEnumFromJSON,
    GenderEnumFromJSONTyped,
    GenderEnumToJSON,
    GenderEnumToJSONTyped,
} from './GenderEnum';

/**
 * Request to create a patient
 * @export
 * @interface CreatePatientRequest
 */
export interface CreatePatientRequest {
    /**
     * Firstname of patient
     * @type {string}
     * @memberof CreatePatientRequest
     */
    firstname?: string;
    /**
     * Lastname of patient
     * @type {string}
     * @memberof CreatePatientRequest
     */
    lastname?: string;
    /**
     * email of patient
     * @type {string}
     * @memberof CreatePatientRequest
     */
    mail?: string;
    /**
     * Birthdate of patient
     * @type {string}
     * @memberof CreatePatientRequest
     */
    birthdate?: string;
    /**
     * 
     * @type {GenderEnum}
     * @memberof CreatePatientRequest
     */
    gender?: GenderEnum;
    /**
     * Serial number of patient
     * @type {string}
     * @memberof CreatePatientRequest
     */
    serialNumber?: string;
    /**
     * 
     * @type {Address}
     * @memberof CreatePatientRequest
     */
    address?: Address;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof CreatePatientRequest
     */
    phone?: PhoneNumber;
}



/**
 * Check if a given object implements the CreatePatientRequest interface.
 */
export function instanceOfCreatePatientRequest(value: object): value is CreatePatientRequest {
    return true;
}

export function CreatePatientRequestFromJSON(json: any): CreatePatientRequest {
    return CreatePatientRequestFromJSONTyped(json, false);
}

export function CreatePatientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePatientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'birthdate': json['birthdate'] == null ? undefined : json['birthdate'],
        'gender': json['gender'] == null ? undefined : GenderEnumFromJSON(json['gender']),
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'phone': json['phone'] == null ? undefined : PhoneNumberFromJSON(json['phone']),
    };
}

export function CreatePatientRequestToJSON(json: any): CreatePatientRequest {
    return CreatePatientRequestToJSONTyped(json, false);
}

export function CreatePatientRequestToJSONTyped(value?: CreatePatientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'mail': value['mail'],
        'birthdate': value['birthdate'],
        'gender': GenderEnumToJSON(value['gender']),
        'serialNumber': value['serialNumber'],
        'address': AddressToJSON(value['address']),
        'phone': PhoneNumberToJSON(value['phone']),
    };
}

